export class PublicAppError extends Error {
  public readonly code: string;

  public constructor(code: string, message: string) {
    super(message);
    this.name = "PublicAppError";
    this.code = code;
  }
}

export function publicMessage(error: unknown): string {
  if (error instanceof PublicAppError) return error.message;
  return "Não foi possível concluir a operação. Tente novamente.";
}

export function fromSupabaseError(error: { code?: string } | null): PublicAppError | null {
  if (error === null) return null;
  if (error.code === "42501") {
    return new PublicAppError("forbidden", "Esta ação não está disponível para sua conta.");
  }
  if (error.code === "23505") {
    return new PublicAppError("conflict", "Este registro já existe.");
  }
  return new PublicAppError("request_failed", "Não foi possível salvar ou carregar os dados.");
}
